import { render, staticRenderFns } from "./card-relations.vue?vue&type=template&id=9d3b4ed8&"
import script from "./card-relations.vue?vue&type=script&lang=ts&"
export * from "./card-relations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports